import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/content/variables")({
  component: () => (
    <Breadcrumb label="Variables" to="/content/variables">
      <Outlet />
    </Breadcrumb>
  ),
});
